import { Tag } from '@ver-uds/react';
import React from 'react';
import AccessMethodAccordionCard from './AccessMethodAccordionCard';
import { AccessMethodType } from './AccessMethodFormData';

type EmployerCardProps = {
  accessMethod: AccessMethodType.EMPLOYER | AccessMethodType.CHILD;
};

export default function EmployerCard({ accessMethod }: EmployerCardProps): JSX.Element {
  return (
    <AccessMethodAccordionCard
      id="employer"
      label="Employer"
      headerTag={<Tag variant="primary">Most Common</Tag>}
      value={accessMethod}
      body="Your company plans to verify the employment eligibility of its own employees using the E-Verify website."
      moreDetails={
        <>
          <p className="margin-top-3">This account access allows you to:</p>
          <ul>
            <li>Create and manage cases on the E-Verify website for your own employees</li>
            <li>Manage company account information</li>
            <li>Add, edit, and delete users</li>
            <li>Add, edit, and delete locations where employees are hired and complete Form I-9</li>
          </ul>
        </>
      }
    />
  );
}
